export type FeatureState = Record<string, boolean>;

export const isFeatureEnabled = (
  features: FeatureState,
  key: string
): boolean => features[key];

export const hasAnyFeature = (
  features: FeatureState,
  keys: string[]
): boolean => keys.some((key) => features[key]);

export const hasAllFeatures = (
  features: FeatureState,
  keys: string[]
): boolean => keys.every((key) => features[key]);

export const featureStatesAreEqual = (
  a: FeatureState,
  b: FeatureState
): boolean => {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every((key) => a[key] === b[key]);
};
